import Layout from "components/layout";
import { GetServerSidePropsContext, GetStaticProps } from "next";
import { NextSeo, NextSeoProps } from "next-seo";
import { ReactNode } from "react";
import { PrivacyPolicyLayout } from "shared/components/templates/PrivacyPolicy";
import { MetaTag } from "utils/seo";
import getNextSeoProps from "utils/ssr/getNextSeoProps";

interface Props {
  nextSeoProps: NextSeoProps;
}

const PrivacyPolicy = ({ nextSeoProps }: Props) => {
  return (
    <>
      <NextSeo {...nextSeoProps} />
      <PrivacyPolicyLayout />
    </>
  );
};

PrivacyPolicy.getLayout = (page: ReactNode) => {
  return <Layout nav={null}>{page}</Layout>;
};

export const getStaticProps: GetStaticProps = async (
  ctx: GetServerSidePropsContext
) => {
  const nextSeoProps = getNextSeoProps(ctx, {
    title: MetaTag.privacyPolicy.title,
    description: MetaTag.privacyPolicy.description,
  });
  return {
    props: {
      nextSeoProps,
    },
  };
};

export default PrivacyPolicy;
